var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.0391H17.01M17.4 14.0391H18C18.9319 14.0391 19.3978 14.0391 19.7654 14.1913C20.2554 14.3943 20.6448 14.7836 20.8478 15.2737C21 15.6412 21 16.1072 21 17.0391C21 17.9709 21 18.4369 20.8478 18.8044C20.6448 19.2945 20.2554 19.6838 19.7654 19.8868C19.3978 20.0391 18.9319 20.0391 18 20.0391H6C5.06812 20.0391 4.60218 20.0391 4.23463 19.8868C3.74458 19.6838 3.35523 19.2945 3.15224 18.8044C3 18.4369 3 17.9709 3 17.0391C3 16.1072 3 15.6412 3.15224 15.2737C3.35523 14.7836 3.74458 14.3943 4.23463 14.1913C4.60218 14.0391 5.06812 14.0391 6 14.0391H6.6M12 15.0391V4.03906M12 15.0391L9 12.0391M12 15.0391L15 12.0391",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownFile);
export default __webpack_public_path__ + "static/media/downFile.68380cfc9b7bcb0a879a88573571e399.svg";
export { ForwardRef as ReactComponent };